<pds-modal #modal title="Insira o número da NF-e (opcional)" [width]="520">
  <main class="modal__content">
    <form [formGroup]="form">
      <pds-form-field label="Insira o número da NF-e (opcional)">
        <input type="number" formControlName="code" placeholder="Número da NF-e" />
      </pds-form-field>
    </form>

    <p>Esta ação não poderá ser desfeita. Deseja continuar?</p>
    <pds-form-actions>
      <button pdsButton (click)="onClickConfirm(orderId(), formValue.code)" type="button">Enviar pro Omie</button>
    </pds-form-actions>
  </main>
</pds-modal>
